'use client';

import type { PropsWithChildren, ReactNode } from 'react';

import NoSSR from '../NoSSR';
import { FullstoryInit } from './FullStoryInit';

export function FullstoryWrapper({ children }: PropsWithChildren): ReactNode {
	return (
		<>
			<NoSSR>
				<FullstoryInit />
			</NoSSR>
			{children}
		</>
	);
}
